import React from "react";
import { useDropzone } from "react-dropzone";

function Dropzone2({ onDrop, accept, open, files, onRemove }) {
  const { getRootProps, getInputProps, isDragActive } =
    useDropzone({
      accept,
      onDrop,
      maxFiles: 1
    });

  const fileItems = files.map((file) => {
    return (
      <li key={file.path}>
        {file.path} - {file.size} bytes <button className="bg-white border-0" type="button" onClick={() => onRemove(file)}>&#x2715;</button>
      </li>
    )
  });

  return (
    <div>
      <div {...getRootProps({ className: "dropzone" })} className="drag-n-drop-input">
        <input className="input-zone" {...getInputProps()} />
        <div className="text-center">
          {isDragActive ? (
            <p className="dropzone-content">
              Release to drop the file here
            </p>
          ) : (
            <p className="dropzone-content">
              Drag' n' drop some file here, or click to select file
            </p>
          )}
          <button type="button" onClick={open} className="btn">
            Click to select file
          </button>
        </div>
      </div>
      <aside>
        <ul>{fileItems}</ul>
      </aside>
    </div>
  );
}

export default Dropzone2;